var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "media-portal" }, [
    _c("div", { staticClass: "media-portal--inlay" }, [
      _c(
        "div",
        { staticClass: "media-portal--content" },
        [
          _c("cmp-carousel-slider", {
            staticClass: "media-portal--slider",
            attrs: {
              items: _vm.sortedItems,
              idx: _vm.idx,
              "passive-mode": true
            },
            on: {
              "request-change": function($event) {
                _vm.updateIdx($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      props.item.type,
                      _vm._b({ tag: "component" }, "component", props, false)
                    )
                  ]
                }
              },
              {
                key: "arrow-nav",
                fn: function(props) {
                  return [
                    _c(
                      "cmp-carousel-arrow-nav",
                      _vm._b({}, "cmp-carousel-arrow-nav", props, false)
                    )
                  ]
                }
              },
              {
                key: "bullet-nav",
                fn: function(props) {
                  return [
                    _c(
                      "cmp-carousel-bullet-nav",
                      _vm._b({}, "cmp-carousel-bullet-nav", props, false)
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50b6d963", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b6d963","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/media-portal/index.vue
// module id = 417
// module chunks = 5